import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withMarketPreOpen from '../../common/market-pre-open/withMarketPreOpen';
import ScrollComponent from '../../common/ScrollComponent';
import Footer from '../../common/table/Footer';
import Tab from '../../common/tab';
import PreRender from '../../common/PreRender';
import { getQueryParams } from '../../helpers/Common';
import {
  CRITERIAS,
  EXCHANGES,
  mapCriteria,
  mapExchange,
  CurrentCriteriaContext,
} from './Const';
import {
  fetchHeatMap,
  fetchHeatMapSuccess,
  REDUCER_NAME,
  setTopTen,
} from './reducer';
import { ChanelConfig } from './../../../configs/GlobalConfig';
import TabContent from './TabContent';
import messageHub from '../../../core/signalr/SignalrMessageHub';
import './heatmap.scss';
import { compose } from 'redux';
import currentState from './../../helpers/CurrentState';
import ConstCommon from './../../common/Const';
import { getLanguage } from './../../helpers/Language';

const mapQueryExchange = {
  All: EXCHANGES.ALL,
  HOSE: EXCHANGES.HOSE,
  HNX: EXCHANGES.HNX,
  UPCOM: EXCHANGES.UPCOM,
};

const mapQueryCriteria = {
  FrBuyVal: CRITERIAS.BUY_VALUE,
  FrSellVal: CRITERIAS.SELL_VALUE,
  FrBuyVol: CRITERIAS.BUY_VOL,
  FrSellVol: CRITERIAS.SELL_VOL,
  Volume: CRITERIAS.VOLUME,
  Value: CRITERIAS.VALUE,
  MarketCap: CRITERIAS.MARKET_CAP,
};

class HeatMap extends PureComponent {
  constructor(props) {
    super(props);
    const exchangeFromQuery = mapQueryExchange[getQueryParams('exchange')];
    const criteriaFromQuery = mapQueryCriteria[getQueryParams('criteria')];

    this.state = {
      currentExchange:
        exchangeFromQuery ||
        currentState.get(ConstCommon.listComponent.HeatMap, 'exchange') ||
        EXCHANGES.ALL,
      currentCriteria:
        criteriaFromQuery ||
        props.tab ||
        currentState.get(ConstCommon.listComponent.HeatMap, 'criteria') ||
        CRITERIAS.BUY_VALUE,
    };
  }

  componentDidMount() {
    const { currentExchange, currentCriteria } = this.state;
    this.getHeatMap();
    this.subscribe(currentExchange, currentCriteria);
    messageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTickers);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { currentCriteria, currentExchange } = this.state;
    const { locale } = this.props;
    if (
      currentCriteria !== prevState.currentCriteria ||
      currentExchange !== prevState.currentExchange
    ) {
      this.getHeatMap();
      this.unsubscribe(prevState.currentExchange, prevState.currentCriteria);
      this.subscribe(currentExchange, currentCriteria);
    }

    if (locale !== prevProps.locale) {
      this.getHeatMap();
    }
  }

  componentWillUnmount() {
    const { currentCriteria, currentExchange } = this.state;
    this.unsubscribe(currentExchange, currentCriteria);
    messageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTickers);
  }

  getChannelName = (exchange, criteria) => {
    return `${ChanelConfig.HeatMapChanelPrefix}${exchange}${criteria}`;
  };

  subscribe = (exchange, criteria) => {
    messageHub.subscribe(
      this.getChannelName(mapExchange[exchange], mapCriteria[criteria]),
      this.onReceiveHeatMap,
    );
  };

  unsubscribe = (exchange, criteria) => {
    messageHub.unsubscribe(
      this.getChannelName(mapExchange[exchange], mapCriteria[criteria]),
      this.onReceiveHeatMap,
    );
  };

  onReceiveTickers = tickers => {
    const { setTopTen } = this.props;
    setTopTen(tickers);
  };

  onReceiveHeatMap = heatMapData => {
    const { fetchHeatMapSuccess } = this.props;
    const lang = getLanguage();

    switch (lang) {
      case 'en':
        heatMapData.sectors.forEach(el => {
          el.name = el.en_Name;
          el.tickers.forEach(t => {
            t.name = t.en_Name;
          });
        });
        break;
      case 'ja':
        heatMapData.sectors.forEach(el => {
          el.name = el.jp_Name;
          el.tickers.forEach(t => {
            t.name = t.jp_Name;
          });
        });
        break;
      default:
        break;
    }
    fetchHeatMapSuccess({
      data: heatMapData.sectors,
    });
  };

  getHeatMap = () => {
    const { currentCriteria, currentExchange } = this.state;
    const { fetchHeatMap } = this.props;
    if (this.source) {
      this.source.cancel();
      this.source = null;
    }
    this.source = fetchHeatMap({
      Exchange: mapExchange[currentExchange],
      Criteria: mapCriteria[currentCriteria],
    });
  };

  changeExchange = exchange => {
    currentState.add(ConstCommon.listComponent.HeatMap, 'exchange', exchange);
    this.setState({
      currentExchange: exchange,
    });
  };

  changeCriteria = criteria => {
    currentState.add(ConstCommon.listComponent.HeatMap, 'criteria', criteria);
    this.setState({
      currentCriteria: criteria,
    });
  };

  render() {
    const { currentExchange, currentCriteria } = this.state;

    return (
      <PreRender {...this.props}>
        <ScrollComponent>
          <CurrentCriteriaContext.Provider value={currentCriteria}>
            <div className="pl-20 pr-20 h-100 heat-map-wrapper d-flex flex-column">
              <div className="top-nav pt-8 d-flex flex-column flex-fill">
                <Tab
                  currentTab={currentExchange}
                  listTab="heatmap.tab"
                  changeTab={this.changeExchange}
                />
                <div className="flex-fill d-flex flex-column">
                  <TabContent
                    changeCriteria={this.changeCriteria}
                    currentCriteria={currentCriteria}
                  />
                </div>

                <Footer
                  listTextLang={[
                    {
                      text: 'common.table.TABLE_FOOTER_TEXT_WITH_UNIT',
                      style: {},
                    },
                  ]}
                />
              </div>
            </div>
          </CurrentCriteriaContext.Provider>
        </ScrollComponent>
      </PreRender>
    );
  }
}

HeatMap.propTypes = {
  sectors: PropTypes.array.isRequired,
  fetchHeatMap: PropTypes.func.isRequired,
  fetchHeatMapSuccess: PropTypes.func.isRequired,
  setTopTen: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  sectors: state[REDUCER_NAME].sectors,
  locale: state.i18n.locale,
});

const mapDispatchToProps = {
  fetchHeatMap,
  fetchHeatMapSuccess,
  setTopTen,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  //withMarketPreOpen(), -- hidden preopen market clock
)(HeatMap);
